import { http, createConfig } from 'wagmi'
import { base, baseSepolia } from 'wagmi/chains'
import { farcasterMiniApp as miniAppConnector } from '@farcaster/miniapp-wagmi-connector'
import { injected, walletConnect } from 'wagmi/connectors'
// import { metaMask, coinbaseWallet } from '@wagmi/connectors' // Causing build issues

// Contract addresses from deployment - NO FALLBACKS!
const CONTRACT_ADDRESSES = {
  [base.id]: import.meta.env.VITE_NFT_CONTRACT_MAINNET,
  [baseSepolia.id]: import.meta.env.VITE_NFT_CONTRACT_TESTNET
}

const USDC_ADDRESSES = {
  [base.id]: import.meta.env.VITE_USDC_CONTRACT_MAINNET,
  [baseSepolia.id]: import.meta.env.VITE_USDC_CONTRACT_TESTNET
}

// Determine which network to use
const isDevelopment = import.meta.env.DEV
const useTestnet = import.meta.env.VITE_NETWORK === 'testnet'

const chains = useTestnet ? [baseSepolia, base] : [base, baseSepolia]

export const config = createConfig({
  chains,
  transports: {
    [base.id]: http(),
    [baseSepolia.id]: http(),
  },
  connectors: [
    miniAppConnector(), // For Farcaster
    injected(), // For MetaMask, Coinbase Wallet, and all other injected wallets
    ...(import.meta.env.VITE_WALLETCONNECT_PROJECT_ID ? [
      walletConnect({
        projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID,
        metadata: {
          name: 'Farcaster Image Converter',
          description: 'A Farcaster mini app for image conversion',
          url: typeof window !== 'undefined' ? window.location.origin : '',
          icons: []
        },
        showQrModal: true, // Show modal for mobile connection
      })
    ] : [])
  ]
})

export { CONTRACT_ADDRESSES, USDC_ADDRESSES, useTestnet }
